import { useEffect, useState } from "react";
import * as Styles from "./styles";
import DropBinDetails from "./components/drop-bin-details/DropBinDetails";
import { PickItem } from "../../common/models/PickItem";
import axios from "../../common/api/axios";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
export interface TopupProps {
  taskCount: any;
  taskDetails: any;
  configName?: string;
}
export default function MaterialTopup({taskCount, taskDetails}:TopupProps) {
  const [getPickItems, setPickItems] = useState<any[]>([]);
  const [getPickStations, setPickStations] = useState<any[]>([]);
  const [PickItemLoading, setPickItemLoading] = useState(false);
  const [time, setTime] = useState(Date.now());
  const navigate = useNavigate();
  const [stationFirstRow, setStationFirstRow] = useState<string[]>([]);
  const [stationSecondRow, setStationSecondRow] = useState<string[]>([]);
  const sampData = [
    {
        "taskType": "Replenish",
        "id": "140e87a4-3242-4f8b-ba63-58a78e434d1b",
        "replenishTask": {
            "binId": "TOTE01020127",
            "from": {
                "x": 4,
                "y": 4,
                "z": 1
            },
            "skuId": "SAV01",
            "quantity": 10,
            "isApproved": false,
            "binSkus": []
        },
        "isComplete": false,
        "creationDate": "2024-03-07T12:13:20.0583364Z"
    },
    {
        "taskType": "Replenish",
        "id": "2231fbb0-7ad4-4960-956f-5a7f639795c3",
        "replenishTask": {
            "binId": "TOTE01010021",
            "from": {
                "x": 4,
                "y": 4,
                "z": 2
            },
            "skuId": "DET01",
            "quantity": 100,
            "isApproved": false,
            "binSkus": []
        },
        "isComplete": false,
        "creationDate": "2024-03-07T12:12:49.3115806Z"
    }
];
  // GET Pick Items
  const getPickItemsData = async () => {
    try {
      setPickItemLoading(true);
      const res = await axios.get("PickStation/replenishTasks", {
        headers: {
          Accept: "application/json",
          tenantId: 1,
        },
      });
      if (res.status === 200) {
        setPickItems(res.data);
        //setPickItems(sampData);
        setPickItemLoading(false);
      }
    } catch (error: any) {}
  };

  useEffect(() => {
    const fetchStationsForConfig = async () => {
      try {
        setPickItemLoading(true);
        const pickRes = await axios.get("PickStation/pickStations", {
          headers: {
            Accept: "application/json",
            tenantId: 1,
          },
        });
        const pickStations =
          pickRes.status === 200 && Array.isArray(pickRes.data)
            ? pickRes.data
            : [];

        setPickStations(pickStations);
      } catch (_error) {
        setPickStations([]);
      } finally {
        setPickItemLoading(false);
      }
    };

    fetchStationsForConfig();
  }, []);

  useEffect(() => {
    setPickItems(taskDetails);
  }, [])
  useEffect(() => {
    setPickItems(taskDetails);
  }, []) 
  
  useEffect(() => {
    if (Array.isArray(getPickStations) && getPickStations.length > 0) {
      const first: string[] = [];
      const second: string[] = [];
      getPickStations.forEach((station: any) => {
        (station.gates || []).forEach((gate: any) => {
          const { x, y, z } = gate.slot || {};
          if (x !== undefined && y !== undefined && z !== undefined) {
            const coord = `${x},${y},${z}`;
            if (z === 2) first.push(coord);
            else if (z === 1) second.push(coord);
          }
        })
      });
      // Sort by x descending
      first.sort((a: string, b: string) => Number(b.split(',')[0]) - Number(a.split(',')[0]));
      second.sort((a: string, b: string) => Number(b.split(',')[0]) - Number(a.split(',')[0]));
      setStationFirstRow(first);
      setStationSecondRow(second);
    } else {
      setStationFirstRow([]);
      setStationSecondRow([]);
    }
  }, [getPickStations]);
  
  /* useEffect(() => {
    if (time) {
      const interval = setInterval(() => {
        setTime(Date.now());
        getPickItemsData();
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [time]); */
  const handleChange = (value: string) => {
    if (value === "task-id") {
      navigate("/task-id");
    } else {
      navigate("order-id");
    }
  };
  return (
    <Styles.Container>
      <DropBinDetails
        pickItemsData={taskDetails}
        pickStationsFirstData={stationFirstRow}
        pickStationsSecondData={stationSecondRow}
      />
    </Styles.Container>
  );
}
